import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * @class FileGenerator
 * A class for generating files such as PDFs from HTML elements.
 */
class FileGenerator {
    /**
     * Saves the specified HTML element as a PDF.
     * @param {HTMLElement} element - The HTML element to be converted into a PDF.
     * @param {string} [filename='document.pdf'] - The name of the file to be saved.
     * @returns {void}
     */
    saveAsPDF(element, filename = 'document.pdf') {
        const doc = new jsPDF();
        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            doc.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
            doc.save(filename);
        }).catch((error) => {
            console.error('Error generating PDF:', error);
        });
    }
}


const defaultFileGenerator = new FileGenerator()
export default defaultFileGenerator;
